export enum FrameCornerAssembly {
  WD = '(WD) WELDED FACE',
  WFP = '(WFP) WELDED FULL PROFILE',
  KD = '(KD) KD WITH TABS',
  // KDO = '(KDO) KD OMIT TABS',
}
